import { insertDriftChatBot } from '@coursera-web/growth-upsell';

export const initializeDrift = (slug: string) => {
  const isC4CV = slug.startsWith('c4c-') || slug.startsWith('c4wr-') || slug.startsWith('c4s-');
  if (isC4CV) {
    insertDriftChatBot(window);
  }
};
